
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { globalStore } from "@/store/store";

import ButtonGroup from "../../components/ButtonGroup.vue";

const RATIOS = [
  { label: "Small", value: 1.1 },
  { label: "Normal", value: 1.25 },
  { label: "Large", value: 1.4 }
];

@Component({
  components: {
    ButtonGroup
  }
})
export default class BrandToggleFontSizes extends Vue {
  update(ratio: number) {
    this.$emit("update", ratio);
  }

  ratios = RATIOS;

  get currentRatio() {
    return globalStore.globalSettings.settings.typography.ratio &&
      globalStore.globalSettings.settings.typography.ratio.breakpoint_base
      ? globalStore.globalSettings.settings.typography.ratio.breakpoint_base
      : this.ratios[1].value;
  }

  isActive(ratio: number) {
    return this.currentRatio === ratio;
  }
}
